(function () {
    'use strict';

    angular
        .module('NaviaqWebApp')
        .directive('adminSectionsList', adminSectionsList);

    adminSectionsList.$inject = ['administrationSections', 'authService', '$state', '$translate'];

    function adminSectionsList(administrationSections, authService, $state, $translate) {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                currentState: '<?'
            },
            templateUrl: 'app/administration/admin-sections-list.html',
            link: function (scope) {
                var authData = authService.getAuthData();
                var visibleSections = administrationSections.filter(function (section) {
                    if (section.superuserOnly) {
                        return authData.isSuperuser;
                    }
                    if (section.permission) {
                        return authService.hasPermission(section.permission);
                    }
                    return true;
                });

                buildSortedSections();
                scope.$on('langChanged', buildSortedSections);
                scope.$watch('currentState', buildSortedSections);

                function buildSortedSections() {
                    scope.sections = visibleSections
                        .map(function (section) {
                            return { section: section, text: $translate.instant(section.titleKey) };
                        })
                        .sort(function (a, b) {
                            return a.text.localeCompare(b.text, 'nb-NO', { sensitivity: 'base' });
                        })
                        .map(function (entry) {
                            return entry.section;
                        });
                }

                scope.isCurrent = function (section) {
                    return section.state === scope.currentState;
                };

                scope.navigateToSection = function (section) {
                    $state.go(section.state);
                };
            }
        };
    }
})();
